import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { emptyFragment } from '../../../EmptyFragment';
import GroupsStore from '../../../GroupsStore';
import { findLink } from '../../../LinkyLinky';
import Button from '../../Form/Button';

interface Props {
  groupsStore: GroupsStore;
}

/**
 * "Add Group" button on the Groups list. Navigates to the full-page
 * Add Group workflow at /people/groups/new.
 *
 * The `modalStore` / `groupStore` props once required by the old
 * AddEditGroupModal are no longer needed since the modal has been
 * retired for this entry point; callers can drop them.
 */
function AddGroup({ groupsStore }: Props) {
  const navigate = useNavigate();

  return findLink('new', groupsStore.links)
    .map(() => (
      <Button
        className={clsx(
          'cursor-pointer rounded-md border border-solid font-semibold',
          'border-primary bg-primary px-4 py-2 text-sm text-primary-foreground',
        )}
        value="+ Add Group"
        type="button"
        onClick={() => navigate('/people/groups/new')}
      />
    ))
    .getOrElse(emptyFragment);
}

export default observer(AddGroup);
